import React from 'react';
import { useAtomValue } from 'jotai';
import useShareSet from '@components/share/useShareSet';
import { metricPanelShareAtom } from '@components/metrics-panel-hz/atoms';
import { panelsAtom, currentKpiIdAtom } from '@src/atoms/panels';
import { diagnosticsAtom } from '@src/atoms/toggles';
import {
  isTableCompareEnabledAtom,
  dimensionPanelShareAtom,
} from '@src/components/dimension-panel-hz/atoms/index';
import { sharingSelector } from '@src/store/trends/sharing/selectors';
import { useSelector } from 'react-redux';
import { isAppModule } from '@src/utils/constants';
import { SHARE_SERVICE_DASHBOARD_KEYS } from '@src/components/share/utils';
import {
  globalFilterRulesExpandedAtom,
  globalFilterAppendedAtomStatusAtom,
} from '@src/components/filter/global-atoms';
import { useWidgetStateForSave } from '@src/components/widget-panel/state/dashboard';

// ideally share data should be set by each section/component like export
// because of the large redux state on old trends it's difficult to break it up now
// we should do it after depricating old trends

function LatchShare() {
  const pageKey = isAppModule
    ? SHARE_SERVICE_DASHBOARD_KEYS.APP_EXPERIENCE
    : SHARE_SERVICE_DASHBOARD_KEYS.TRENDS;
  const sharingState = useSelector(sharingSelector);
  const metricPanel = useAtomValue(metricPanelShareAtom);
  const dimensionPanel = useAtomValue(dimensionPanelShareAtom);
  const sections = useAtomValue(panelsAtom);
  const diagnostics = useAtomValue(diagnosticsAtom);
  const isTableCompareEnabled = useAtomValue(isTableCompareEnabledAtom);
  const globalFilterRulesExpanded = useAtomValue(globalFilterRulesExpandedAtom);
  const globalFilterAppendedAtomStatus = useAtomValue(globalFilterAppendedAtomStatusAtom);
  const currentKpiId = useAtomValue(currentKpiIdAtom);

  const { state, ...meta } = sharingState;

  const widgetState = useWidgetStateForSave();

  const formattedState = {
    ...meta,
    state: {
      ...state,
      metricPanel,
      isTableCompareEnabled,
      dimensionPanel,
      toggles: {
        sections,
        diagnostics,
      },
      globalFilter: {
        rulesExpanded: globalFilterRulesExpanded,
        appendedAtomStatus: globalFilterAppendedAtomStatus,
      },
      widgetState,
      // currentKpiId,
      currentKpiIdSelected: currentKpiId,
    },
  };

  useShareSet({ pageKey, state: formattedState });

  return <></>;
}

export default LatchShare;
